export default __webpack_public_path__ + "static/media/auction.7f48c547.png";